module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00084-fs8.d6ca9ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00084-fs8.png
// module id = 237
// module chunks = 0